import React from 'react';
import { Row, Col, FormGroup } from 'react-bootstrap';
import { SearchBox, Combo, TextBox } from 'fw/forms';
import { Button } from 'fw/components';
import { SetupSearch } from 'areas/shared/pages/setup';
import { EmployeesRangeCombo, StateMultiCombo, GeographicMarketCombo, BusinessOwnershipMultiCombo } from 'areas/shared/controls';
import { ConnectToVOBSearchHelpers } from 'areas/shared/helpers';

class Search extends SetupSearch {
    initialState() {
        return {
            list: [],
            loading: false
        };
    }

    initialForm() {
        return {
            name: "",
            nAICSCodes: [{ value: "", label: "" }],
            stateCodes: [],
            businessOwnershipIds: []
        };
    }

    ready = () => {
    }

	handleUpdateForm = (form) => {
		this.setState({ form });
	}

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={3} style={{ paddingRight: 10 }}>
                        <FormGroup>
                            <TextBox
                                name="keywords"
                                placeholder="Keyword Search"
                                ref={(c) => { this.focusControl = c }} />
                        </FormGroup>
                        <FormGroup>
                            <SearchBox
                                name="vobName"
                                label="name"
                                placeholder="Company/DBA Name"
                                loader={ConnectToVOBSearchHelpers.searchCompanyLoader}
                                clearable />
                        </FormGroup>
                        <FormGroup>
                            <TextBox
                                name="professionalAccreditation"
                                placeholder="Professional Accreditation" />
                        </FormGroup>
                    </Col>
                    <Col md={3} style={{ paddingLeft: 10, paddingRight: 10 }}>
                        <FormGroup>
                            <SearchBox
                                name="veteranOwnerName"
                                label="veteranOwnerName"
                                placeholder="Veteran Name"
                                loader={ConnectToVOBSearchHelpers.searchVeteranLoader}
                                clearable />
                        </FormGroup>
                        <Row>
                            <Col md={12}>
                                {this.state.form.nAICSCodes != null && this.state.form.nAICSCodes.length > 0 && (
                                    <React.Fragment>
                                        {ConnectToVOBSearchHelpers.renderNAICs(this.state.form, this.handleUpdateForm)}
                                    </React.Fragment>
                                )}
								<Button type="button" bsStyle="link" onClick={() => ConnectToVOBSearchHelpers.handleAddAnotherNAIC(this.state.form, this.handleUpdateForm)}>
									Search for another NAICS Code
								</Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={3} style={{ paddingLeft: 10, paddingRight: 10 }}>
                        <FormGroup>
                            <StateMultiCombo
                                name="stateCodes"
                                placeholder="State(s)"
                                clearable />
                        </FormGroup>
                        <FormGroup>
                            <GeographicMarketCombo
                                name="geographicalMarketId"
                                placeholder="Geographical Market"
                                clearable />
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <Row>
                                <Col md={6} style={{ paddingRight: 10 }}>
                                    <EmployeesRangeCombo
                                        name="employeeAmount"
                                        placeholder="Employees"
                                        clearable />
                                </Col>
                                <Col md={6} style={{ paddingLeft: 10 }}>
                                    <Combo
                                        name="veteranServiceConnectedDisabled"
                                        placeholder="SDVS"
                                        items={{ "True": "SDVOB", "False": "VOB" }}
                                        clearable />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <BusinessOwnershipMultiCombo
                                name="businessOwnershipIds"
                                placeholder="Business Ownership(s)"
                                clearable />
                        </FormGroup>
                    </Col>
                </Row >
            </React.Fragment >

        )
    }
}

export default Search;



// WEBPACK FOOTER //
// ./src/areas/companyManagement/connectToVOB/Search.js